<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/empresa"> Cadastro/Empresa </router-link>
      <label class="labelBar"> / </label>
      <label> Criar</label>
    </div>
    <v-container fluid>
      <v-row class="text-center">
        <v-col cols="12">
          <div class="float-right">
            <avatar ref="avatar" :styleTile="true" :title="title" :isAllowed="true" />
          </div>
        </v-col>
      </v-row>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col cols="12" sm="12">
            <v-text-field
              label="Empresa *"
              v-model="nome"
              :counter="200"
              :rules="[(v) => !!v || 'A Empresa é obrigatória']"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="12" sm="4">
            <v-text-field
              label="CNPJ/CPF *"
              v-model="cpf_cnpj"
              v-mask="['###.###.###-##', '##.###.###/####-##']"
              :counter="18"
              :rules="[(v) => !!v || 'O preenchimento do CPF/CNPJ é obrigatório']"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              label="Telefone *"
              v-model="telefone"
              v-mask="['(##) ####-####', '(##) #####-####']"
              :counter="15"
              :rules="[(v) => !!v || 'O Telefone é obrigatório']"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              label="IE *"
              v-model="inscricaoEstadual"
              :counter="100"
              :rules="[(v) => !!v || 'A Inscrição Estadual é obrigatória']"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <endereco ref="endereco" />
      </v-form>
      <v-row align="center">
        <v-col class="text-right">
          <v-btn to="/empresa" color="error" class="mr-4"> Voltar </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4"> Salvar </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import { enviarEmpresaAsync } from "../../../services/empresaService";
import Avatar from "../../Avatar/AvatarCard";
import Endereco from "../Endereco";

export default {
  name: "criarEmpresa",
  data: () => ({
    overlay: false,
    valid: true,
    title: "Upload Imagem",
    nome: null,
    cpf_cnpj: null,
    inscricaoEstadual: null,
    telefone: null,
  }),
  methods: {
    async enviar() {
      var enderecoValido = this.$refs.endereco.updateObjectEstate();
      if (this.$refs.form.validate() && enderecoValido) {
        this.overlay = true;
        var img = this.$refs.avatar.getImg();
        const resposta = await enviarEmpresaAsync(
          this.nome,
          this.cpf_cnpj,
          this.inscricaoEstadual,
          this.telefone,
          this.$refs.endereco.cep,
          this.$refs.endereco.logradouro,
          this.$refs.endereco.numero,
          this.$refs.endereco.complemento,
          this.$refs.endereco.bairro,
          this.$refs.endereco.cidade,
          this.$refs.endereco.uf,
          img
        );
        if (resposta) {
          //this.mensagemErro = resposta;
          //this.mostartMensagemErro = true;
          this.overlay = false;
          this.$alert(resposta.message, "Descupe, falha na operação!", "error");
        } else {
          this.overlay = false;
          this.$router.push("/empresa");
        }
      }
    },
  },
  components: {
    Avatar,
    Endereco,
  },
};
</script>